import type React from "react";
import type { FieldGroupProps } from "ui/Form/Element/FieldGroup";
import type { LabelProps } from "ui/Form/Element/Label";

export const profileLabelClassName = "mb-2 block text-sm font-semibold text-gray-900";

export const profileFieldGroupClassName = "space-y-2";

export function profileLabelProps(label: React.ReactNode, required?: boolean): LabelProps & { label: React.ReactNode } {
    return {
        label,
        className: profileLabelClassName,
        required,
    };
}

export function profileFieldGroupProps(className?: string): FieldGroupProps {
    return {
        className: [profileFieldGroupClassName, className].filter(Boolean).join(" "),
    };
}
